import { string } from "yup";

const ErrorMessage = "Hex color format required: #XXXXXX";
export const HexColor = string()
  .length(7, ErrorMessage)
  .matches(/^#([A-Fa-f0-9]{6})$/, ErrorMessage)
  .transform((value) => (value === "" ? null : value))
  .uppercase();
